var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsurance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#497FC1"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D5D92"
    },
    d: "M512,256c0-3.628-0.095-7.234-0.244-10.826l-136.46-136.46c-0.137-0.139-0.277-0.276-0.414-0.414 l-0.208-0.208l-0.001,0.001C344.319,77.69,302.36,58.875,256,58.875l0,0l0,0c-0.001,0-0.001,0-0.001,0 c-92.165,0.001-166.954,74.344-167.701,166.332l156.335,156.335v17.779c0,11.163,4.488,21.294,11.748,28.698l-0.007,0.007 l73.219,73.219C435.104,469.627,512,371.801,512,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E25F3F"
    },
    d: "M423.702,225.208C422.954,133.219,348.165,58.876,256,58.876S89.046,133.219,88.298,225.208 L423.702,225.208L423.702,225.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2482A"
    },
    d: "M256,225.208h167.702C422.954,133.219,348.165,58.875,256,58.875l0,0V225.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A16125"
    },
    d: "M285.652,440.34c-22.618,0-41.019-18.401-41.019-41.019V197.683h22.734V399.32 c0,10.083,8.203,18.286,18.286,18.286s18.286-8.203,18.286-18.286v-20.428h22.734v20.428 C326.672,421.938,308.27,440.34,285.652,440.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E57654"
    },
    d: "M367.633,225.208C367.136,133.219,317.351,58.876,256,58.876s-111.136,74.343-111.633,166.332 H367.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E25F3F"
    },
    d: "M256,58.875v166.332h111.633C367.136,133.219,317.351,58.875,256,58.875L256,58.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA9277"
    },
    d: "M305.378,225.208C305.158,133.219,283.137,58.876,256,58.876s-49.158,74.343-49.378,166.332 L305.378,225.208L305.378,225.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E57654"
    },
    d: "M305.378,225.208C305.158,133.219,283.137,58.875,256,58.875v166.332L305.378,225.208 L305.378,225.208z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.035a35eaab4a2e9b8e44abb53d6106df.svg";
export { ForwardRef as ReactComponent };